import React from 'react';
import { Grid } from '@material-ui/core';
import { compose, withState } from 'recompose';
import { CanUserEditOPENSetupConfig } from 'appconstants/Permission';
import { RenderEditable, RenderElement } from 'components/RenderHelpers';
import EditOpenSetupConfig from './EditOpenSetupConfig';
import ViewOpenSetupConfig from './ViewOpenSetupConfig';

const openConfigUI = ({
  data, protocolNumber, protocolId, state, saveConfig, setState, isDisableEditButton
}) => (
  <Grid container spacing={4}>
    <Grid item xs>
      <RenderEditable
        state={state}
        editable={CanUserEditOPENSetupConfig()}
        setState={setState}
        title="OPEN Configuration"
        editDisabled={isDisableEditButton}
      >
        <RenderElement access={state === true}>
          <EditOpenSetupConfig
            isDisableEditButton={isDisableEditButton}
            openConfig={data}
            saveConfig={saveConfig}
            protocolNumber={protocolNumber}
            protocolId={protocolId}
            closeConfig={() => setState(!state)}
          />
        </RenderElement>
        <RenderElement access={state === false}>
          <ViewOpenSetupConfig openConfig={data} />
        </RenderElement>
      </RenderEditable>
    </Grid>
  </Grid>
);

const OpenSetupConfigs = compose(withState('state', 'setState', false))(openConfigUI);

export default OpenSetupConfigs;
